//frontend/src/site/builder/siteSections.js
// ✅ Mapa oficial de seções por MODELO (ordem fixa + ids conhecidos)
// ETAPA 03: evita bagunça e garante que o editor só mostre o que pode.

export const SITE_MODELS = {
  corretor: {
    id: 'corretor',
    label: 'Corretor como figura central',
    sections: [
      { id: 'hero', ativo: true },
      { id: 'sobre', ativo: true },
      { id: 'imoveis', ativo: true }, // destaque/recentes
      { id: 'servicos', ativo: true },
      { id: 'provaSocial', ativo: true },
      { id: 'ctaFinal', ativo: true },
      { id: 'rodape', ativo: true },
    ],
  },

  imobiliaria: {
    id: 'imobiliaria',
    label: 'Imobiliária (Hero full + filtro + destaques + terrenos + CTA)',
    sections: [
      { id: 'hero', ativo: true },
      { id: 'destaques', ativo: true }, // ✅ imóveis em destaque (manual/fallback)
      { id: 'terrenos', ativo: true }, // ✅ últimos 6 terrenos
      { id: 'ctaFinal', ativo: true },
      { id: 'rodape', ativo: true },
    ],
  },
};

// fallback seguro
export function resolveModelId(modelId) {
  const key = String(modelId || '')
    .trim()
    .toLowerCase();
  return SITE_MODELS[key] ? key : 'corretor';
}

export function getModelSections(modelId) {
  const mid = resolveModelId(modelId);
  return SITE_MODELS[mid].sections;
}
